// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "unconfirmedTransaction.proto" (package "transaction", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SplitOverride } from "./transaction";
/**
 * @generated from protobuf message transaction.UnconfirmedTransaction
 */
export interface UnconfirmedTransaction {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 transaction_group = 2
     */
    transactionGroup: number;
    /**
     * @generated from protobuf field: string owner = 3
     */
    owner: string;
    /**
     * @generated from protobuf field: string created_by = 4
     */
    createdBy: string;
    /**
     * @generated from protobuf field: uint32 amount = 5
     */
    amount: number; // in the group currency
    /**
     * @generated from protobuf field: string date = 6
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 7
     */
    note: string;
    /**
     * @generated from protobuf field: optional transaction.SplitOverride split_override = 8
     */
    splitOverride?: SplitOverride;
}
/**
 * @generated from protobuf message transaction.GetAllUnconfirmedTransactionsRequest
 */
export interface GetAllUnconfirmedTransactionsRequest {
}
/**
 * @generated from protobuf message transaction.GetAllUnconfirmedTransactionsResponse
 */
export interface GetAllUnconfirmedTransactionsResponse {
    /**
     * @generated from protobuf field: repeated transaction.UnconfirmedTransaction unconfirmed_transactions = 1
     */
    unconfirmedTransactions: UnconfirmedTransaction[];
}
/**
 * @generated from protobuf message transaction.CreateUnconfirmedTransactionRequest
 */
export interface CreateUnconfirmedTransactionRequest {
    /**
     * @generated from protobuf field: uint32 transaction_group = 1
     */
    transactionGroup: number;
    /**
     * @generated from protobuf field: string owner = 2
     */
    owner: string;
    /**
     * @generated from protobuf field: uint32 amount = 3
     */
    amount: number;
    /**
     * @generated from protobuf field: string date = 4
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 5
     */
    note: string;
    /**
     * @generated from protobuf field: optional transaction.SplitOverride split_override = 6
     */
    splitOverride?: SplitOverride;
}
/**
 * @generated from protobuf message transaction.CreateUnconfirmedTransactionResponse
 */
export interface CreateUnconfirmedTransactionResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.UpdateUnconfirmedTransactionFields
 */
export interface UpdateUnconfirmedTransactionFields {
    /**
     * @generated from protobuf field: optional string owner = 1
     */
    owner?: string;
    /**
     * @generated from protobuf field: optional uint32 amount = 2
     */
    amount?: number;
    /**
     * @generated from protobuf field: optional string date = 3
     */
    date?: string;
    /**
     * @generated from protobuf field: optional string note = 4
     */
    note?: string;
    /**
     * @generated from protobuf field: bool update_split_override = 5
     */
    updateSplitOverride: boolean;
    /**
     * @generated from protobuf field: optional transaction.SplitOverride split_override = 6
     */
    splitOverride?: SplitOverride;
}
/**
 * @generated from protobuf message transaction.UpdateUnconfirmedTransactionRequest
 */
export interface UpdateUnconfirmedTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: transaction.UpdateUnconfirmedTransactionFields fields = 2
     */
    fields?: UpdateUnconfirmedTransactionFields;
}
/**
 * @generated from protobuf message transaction.UpdateUnconfirmedTransactionResponse
 */
export interface UpdateUnconfirmedTransactionResponse {
}
/**
 * @generated from protobuf message transaction.DeleteUnconfirmedTransactionRequest
 */
export interface DeleteUnconfirmedTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.DeleteUnconfirmedTransactionResponse
 */
export interface DeleteUnconfirmedTransactionResponse {
}
/**
 * @generated from protobuf message transaction.PromoteUnconfirmedTransactionRequest
 */
export interface PromoteUnconfirmedTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 amount = 2
     */
    amount: number;
    /**
     * @generated from protobuf field: uint32 currency = 3
     */
    currency: number;
    /**
     * @generated from protobuf field: optional uint32 sender = 4
     */
    sender?: number;
    /**
     * @generated from protobuf field: optional uint32 receiver = 5
     */
    receiver?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 6
     */
    category?: number;
    /**
     * @generated from protobuf field: string date = 7
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 8
     */
    note: string;
    /**
     * @generated from protobuf field: uint32 receiver_currency = 9
     */
    receiverCurrency: number;
    /**
     * @generated from protobuf field: uint32 receiver_amount = 10
     */
    receiverAmount: number;
}
/**
 * @generated from protobuf message transaction.PromoteUnconfirmedTransactionResponse
 */
export interface PromoteUnconfirmedTransactionResponse {
    /**
     * @generated from protobuf field: uint32 transaction_id = 1
     */
    transactionId: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class UnconfirmedTransaction$Type extends MessageType<UnconfirmedTransaction> {
    constructor() {
        super("transaction.UnconfirmedTransaction", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "transaction_group", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "owner", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "split_override", kind: "message", T: () => SplitOverride }
        ]);
    }
    create(value?: PartialMessage<UnconfirmedTransaction>): UnconfirmedTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.transactionGroup = 0;
        message.owner = "";
        message.createdBy = "";
        message.amount = 0;
        message.date = "";
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial<UnconfirmedTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnconfirmedTransaction): UnconfirmedTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 transaction_group */ 2:
                    message.transactionGroup = reader.uint32();
                    break;
                case /* string owner */ 3:
                    message.owner = reader.string();
                    break;
                case /* string created_by */ 4:
                    message.createdBy = reader.string();
                    break;
                case /* uint32 amount */ 5:
                    message.amount = reader.uint32();
                    break;
                case /* string date */ 6:
                    message.date = reader.string();
                    break;
                case /* string note */ 7:
                    message.note = reader.string();
                    break;
                case /* optional transaction.SplitOverride split_override */ 8:
                    message.splitOverride = SplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.splitOverride);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnconfirmedTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 transaction_group = 2; */
        if (message.transactionGroup !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactionGroup);
        /* string owner = 3; */
        if (message.owner !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.owner);
        /* string created_by = 4; */
        if (message.createdBy !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdBy);
        /* uint32 amount = 5; */
        if (message.amount !== 0)
            writer.tag(5, WireType.Varint).uint32(message.amount);
        /* string date = 6; */
        if (message.date !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.date);
        /* string note = 7; */
        if (message.note !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.note);
        /* optional transaction.SplitOverride split_override = 8; */
        if (message.splitOverride)
            SplitOverride.internalBinaryWrite(message.splitOverride, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UnconfirmedTransaction
 */
export const UnconfirmedTransaction = new UnconfirmedTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllUnconfirmedTransactionsRequest$Type extends MessageType<GetAllUnconfirmedTransactionsRequest> {
    constructor() {
        super("transaction.GetAllUnconfirmedTransactionsRequest", []);
    }
    create(value?: PartialMessage<GetAllUnconfirmedTransactionsRequest>): GetAllUnconfirmedTransactionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllUnconfirmedTransactionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllUnconfirmedTransactionsRequest): GetAllUnconfirmedTransactionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllUnconfirmedTransactionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllUnconfirmedTransactionsRequest
 */
export const GetAllUnconfirmedTransactionsRequest = new GetAllUnconfirmedTransactionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllUnconfirmedTransactionsResponse$Type extends MessageType<GetAllUnconfirmedTransactionsResponse> {
    constructor() {
        super("transaction.GetAllUnconfirmedTransactionsResponse", [
            { no: 1, name: "unconfirmed_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UnconfirmedTransaction }
        ]);
    }
    create(value?: PartialMessage<GetAllUnconfirmedTransactionsResponse>): GetAllUnconfirmedTransactionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.unconfirmedTransactions = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllUnconfirmedTransactionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllUnconfirmedTransactionsResponse): GetAllUnconfirmedTransactionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.UnconfirmedTransaction unconfirmed_transactions */ 1:
                    message.unconfirmedTransactions.push(UnconfirmedTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllUnconfirmedTransactionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.UnconfirmedTransaction unconfirmed_transactions = 1; */
        for (let i = 0; i < message.unconfirmedTransactions.length; i++)
            UnconfirmedTransaction.internalBinaryWrite(message.unconfirmedTransactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllUnconfirmedTransactionsResponse
 */
export const GetAllUnconfirmedTransactionsResponse = new GetAllUnconfirmedTransactionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUnconfirmedTransactionRequest$Type extends MessageType<CreateUnconfirmedTransactionRequest> {
    constructor() {
        super("transaction.CreateUnconfirmedTransactionRequest", [
            { no: 1, name: "transaction_group", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "owner", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "split_override", kind: "message", T: () => SplitOverride }
        ]);
    }
    create(value?: PartialMessage<CreateUnconfirmedTransactionRequest>): CreateUnconfirmedTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionGroup = 0;
        message.owner = "";
        message.amount = 0;
        message.date = "";
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial<CreateUnconfirmedTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateUnconfirmedTransactionRequest): CreateUnconfirmedTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_group */ 1:
                    message.transactionGroup = reader.uint32();
                    break;
                case /* string owner */ 2:
                    message.owner = reader.string();
                    break;
                case /* uint32 amount */ 3:
                    message.amount = reader.uint32();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                case /* string note */ 5:
                    message.note = reader.string();
                    break;
                case /* optional transaction.SplitOverride split_override */ 6:
                    message.splitOverride = SplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.splitOverride);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateUnconfirmedTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_group = 1; */
        if (message.transactionGroup !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionGroup);
        /* string owner = 2; */
        if (message.owner !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.owner);
        /* uint32 amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.amount);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        /* string note = 5; */
        if (message.note !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.note);
        /* optional transaction.SplitOverride split_override = 6; */
        if (message.splitOverride)
            SplitOverride.internalBinaryWrite(message.splitOverride, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateUnconfirmedTransactionRequest
 */
export const CreateUnconfirmedTransactionRequest = new CreateUnconfirmedTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUnconfirmedTransactionResponse$Type extends MessageType<CreateUnconfirmedTransactionResponse> {
    constructor() {
        super("transaction.CreateUnconfirmedTransactionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateUnconfirmedTransactionResponse>): CreateUnconfirmedTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateUnconfirmedTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateUnconfirmedTransactionResponse): CreateUnconfirmedTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateUnconfirmedTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateUnconfirmedTransactionResponse
 */
export const CreateUnconfirmedTransactionResponse = new CreateUnconfirmedTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUnconfirmedTransactionFields$Type extends MessageType<UpdateUnconfirmedTransactionFields> {
    constructor() {
        super("transaction.UpdateUnconfirmedTransactionFields", [
            { no: 1, name: "owner", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "date", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "note", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "update_split_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "split_override", kind: "message", T: () => SplitOverride }
        ]);
    }
    create(value?: PartialMessage<UpdateUnconfirmedTransactionFields>): UpdateUnconfirmedTransactionFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateSplitOverride = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateUnconfirmedTransactionFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUnconfirmedTransactionFields): UpdateUnconfirmedTransactionFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string owner */ 1:
                    message.owner = reader.string();
                    break;
                case /* optional uint32 amount */ 2:
                    message.amount = reader.uint32();
                    break;
                case /* optional string date */ 3:
                    message.date = reader.string();
                    break;
                case /* optional string note */ 4:
                    message.note = reader.string();
                    break;
                case /* bool update_split_override */ 5:
                    message.updateSplitOverride = reader.bool();
                    break;
                case /* optional transaction.SplitOverride split_override */ 6:
                    message.splitOverride = SplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.splitOverride);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUnconfirmedTransactionFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string owner = 1; */
        if (message.owner !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.owner);
        /* optional uint32 amount = 2; */
        if (message.amount !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.amount);
        /* optional string date = 3; */
        if (message.date !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.date);
        /* optional string note = 4; */
        if (message.note !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.note);
        /* bool update_split_override = 5; */
        if (message.updateSplitOverride !== false)
            writer.tag(5, WireType.Varint).bool(message.updateSplitOverride);
        /* optional transaction.SplitOverride split_override = 6; */
        if (message.splitOverride)
            SplitOverride.internalBinaryWrite(message.splitOverride, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateUnconfirmedTransactionFields
 */
export const UpdateUnconfirmedTransactionFields = new UpdateUnconfirmedTransactionFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUnconfirmedTransactionRequest$Type extends MessageType<UpdateUnconfirmedTransactionRequest> {
    constructor() {
        super("transaction.UpdateUnconfirmedTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => UpdateUnconfirmedTransactionFields }
        ]);
    }
    create(value?: PartialMessage<UpdateUnconfirmedTransactionRequest>): UpdateUnconfirmedTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateUnconfirmedTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUnconfirmedTransactionRequest): UpdateUnconfirmedTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* transaction.UpdateUnconfirmedTransactionFields fields */ 2:
                    message.fields = UpdateUnconfirmedTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUnconfirmedTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* transaction.UpdateUnconfirmedTransactionFields fields = 2; */
        if (message.fields)
            UpdateUnconfirmedTransactionFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateUnconfirmedTransactionRequest
 */
export const UpdateUnconfirmedTransactionRequest = new UpdateUnconfirmedTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUnconfirmedTransactionResponse$Type extends MessageType<UpdateUnconfirmedTransactionResponse> {
    constructor() {
        super("transaction.UpdateUnconfirmedTransactionResponse", []);
    }
    create(value?: PartialMessage<UpdateUnconfirmedTransactionResponse>): UpdateUnconfirmedTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateUnconfirmedTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUnconfirmedTransactionResponse): UpdateUnconfirmedTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUnconfirmedTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateUnconfirmedTransactionResponse
 */
export const UpdateUnconfirmedTransactionResponse = new UpdateUnconfirmedTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUnconfirmedTransactionRequest$Type extends MessageType<DeleteUnconfirmedTransactionRequest> {
    constructor() {
        super("transaction.DeleteUnconfirmedTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteUnconfirmedTransactionRequest>): DeleteUnconfirmedTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteUnconfirmedTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteUnconfirmedTransactionRequest): DeleteUnconfirmedTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteUnconfirmedTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteUnconfirmedTransactionRequest
 */
export const DeleteUnconfirmedTransactionRequest = new DeleteUnconfirmedTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUnconfirmedTransactionResponse$Type extends MessageType<DeleteUnconfirmedTransactionResponse> {
    constructor() {
        super("transaction.DeleteUnconfirmedTransactionResponse", []);
    }
    create(value?: PartialMessage<DeleteUnconfirmedTransactionResponse>): DeleteUnconfirmedTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteUnconfirmedTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteUnconfirmedTransactionResponse): DeleteUnconfirmedTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteUnconfirmedTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteUnconfirmedTransactionResponse
 */
export const DeleteUnconfirmedTransactionResponse = new DeleteUnconfirmedTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteUnconfirmedTransactionRequest$Type extends MessageType<PromoteUnconfirmedTransactionRequest> {
    constructor() {
        super("transaction.PromoteUnconfirmedTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "sender", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "receiver", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "receiver_currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "receiver_amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PromoteUnconfirmedTransactionRequest>): PromoteUnconfirmedTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.amount = 0;
        message.currency = 0;
        message.date = "";
        message.note = "";
        message.receiverCurrency = 0;
        message.receiverAmount = 0;
        if (value !== undefined)
            reflectionMergePartial<PromoteUnconfirmedTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PromoteUnconfirmedTransactionRequest): PromoteUnconfirmedTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 amount */ 2:
                    message.amount = reader.uint32();
                    break;
                case /* uint32 currency */ 3:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 sender */ 4:
                    message.sender = reader.uint32();
                    break;
                case /* optional uint32 receiver */ 5:
                    message.receiver = reader.uint32();
                    break;
                case /* optional uint32 category */ 6:
                    message.category = reader.uint32();
                    break;
                case /* string date */ 7:
                    message.date = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* uint32 receiver_currency */ 9:
                    message.receiverCurrency = reader.uint32();
                    break;
                case /* uint32 receiver_amount */ 10:
                    message.receiverAmount = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PromoteUnconfirmedTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).uint32(message.amount);
        /* uint32 currency = 3; */
        if (message.currency !== 0)
            writer.tag(3, WireType.Varint).uint32(message.currency);
        /* optional uint32 sender = 4; */
        if (message.sender !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.sender);
        /* optional uint32 receiver = 5; */
        if (message.receiver !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.receiver);
        /* optional uint32 category = 6; */
        if (message.category !== undefined)
            writer.tag(6, WireType.Varint).uint32(message.category);
        /* string date = 7; */
        if (message.date !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.date);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* uint32 receiver_currency = 9; */
        if (message.receiverCurrency !== 0)
            writer.tag(9, WireType.Varint).uint32(message.receiverCurrency);
        /* uint32 receiver_amount = 10; */
        if (message.receiverAmount !== 0)
            writer.tag(10, WireType.Varint).uint32(message.receiverAmount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.PromoteUnconfirmedTransactionRequest
 */
export const PromoteUnconfirmedTransactionRequest = new PromoteUnconfirmedTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteUnconfirmedTransactionResponse$Type extends MessageType<PromoteUnconfirmedTransactionResponse> {
    constructor() {
        super("transaction.PromoteUnconfirmedTransactionResponse", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PromoteUnconfirmedTransactionResponse>): PromoteUnconfirmedTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionId = 0;
        if (value !== undefined)
            reflectionMergePartial<PromoteUnconfirmedTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PromoteUnconfirmedTransactionResponse): PromoteUnconfirmedTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_id */ 1:
                    message.transactionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PromoteUnconfirmedTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.PromoteUnconfirmedTransactionResponse
 */
export const PromoteUnconfirmedTransactionResponse = new PromoteUnconfirmedTransactionResponse$Type();
/**
 * @generated ServiceType for protobuf service transaction.UnconfirmedTransactionService
 */
export const UnconfirmedTransactionService = new ServiceType("transaction.UnconfirmedTransactionService", [
    { name: "GetAllUnconfirmedTransactions", options: {}, I: GetAllUnconfirmedTransactionsRequest, O: GetAllUnconfirmedTransactionsResponse },
    { name: "CreateUnconfirmedTransaction", options: {}, I: CreateUnconfirmedTransactionRequest, O: CreateUnconfirmedTransactionResponse },
    { name: "UpdateUnconfirmedTransaction", options: {}, I: UpdateUnconfirmedTransactionRequest, O: UpdateUnconfirmedTransactionResponse },
    { name: "DeleteUnconfirmedTransaction", options: {}, I: DeleteUnconfirmedTransactionRequest, O: DeleteUnconfirmedTransactionResponse },
    { name: "PromoteUnconfirmedTransaction", options: {}, I: PromoteUnconfirmedTransactionRequest, O: PromoteUnconfirmedTransactionResponse }
]);
